import { ActionReducer, Action } from '@ngrx/store';
import * as fromActions from './faqs-categories.actions';
import { FaqsCategoriesState } from './faqs-categories.state';


const defaultState: FaqsCategoriesState = {
    loading: true,
    error: '',
    items: [],
    ordersby: [],
    paginator: {
        total: 0,
        perPage: 500,
        currentPage: 1,
        lastPage: 0
    },
    filtersStatus: [
        { value: 1 , name: 'Activo' },
        { value: 0 , name: 'Inactivo' }
    ],
    // search: '',
    currentFilters: {
        textSearch: '',
        status: -1
    },
    refresh: false
};

export type Action = fromActions.All;

export function FaqsCategoriesReducer(state = defaultState, action: any) {
    switch (action.type) {

        case fromActions.DO_GET_INFO_FAQS_CATEGORIES:
            // console.log('pidiendo...');
            return {
                ...state,
                loading: true,
                error: '',
                items: [],
                refresh: false
            };

        case fromActions.DO_GET_INFO_FAQS_CATEGORIES_OK:
            return {
                ...state,
                loading: false,
                items: action.payload.list,
                paginator: {
                    total: action.payload.pagination.total,
                    perPage: action.payload.pagination.limit,
                    currentPage: action.payload.pagination.page,
                    lastPage: action.payload.pagination.pages
                }
            };

        case fromActions.DO_GET_INFO_FAQS_CATEGORIES_KO:
            return {
                ...state,
                loading: false,
                error: action.payload,
                items: [],
                paginator: null
            };

        case fromActions.DO_SET_SELECTED_FILTERS:
            return {
                ...state,
                // loading: false,
                currentFilters: action.payload.filters,
                paginator: action.payload.paginator,
                refresh: true
            };

        default:
            return state;
    }
}
